import { render, staticRenderFns } from "./AppContact.vue?vue&type=template&id=9d031fec"
import script from "./AppContact.vue?vue&type=script&lang=js"
export * from "./AppContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports